import React, { useCallback, useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MenuItem, IconButton, Popover, Box } from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import {
  MoreIcon,
  DeleteIcon,
  UnPinIcon,
  PinBorderIcon,
  PinIcon,
  ShareIcon,
  EditIcon,
  AckDetailIcon,
} from '../../../../components/Icon';
import { i18n } from '../../../../language';
import { authNameE } from '../../../../utils/userFuncs';
import ehandoverIds from '../../../../ids/Ehandover';
import ForwardPopup from '../../../../components/ForwardPopup';
import { userRoleList } from '../../../../utils/userRole';
import AckDetailDialog from '../AckDetailDialog';
import DelDialog from '../../../../components/Dialog';
import UpdateThisOneDialog from '../UpdateThisOneDialog';
import DiaLog from './dialog';
import PinNoteDialog from './PinNoteDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: '1.5rem',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
  },
  btn: {
    borderRadius: '0',
    width: '1.5rem',
    height: '1.5rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  moreIcon: {
    fontSize: '1.125rem',
    color: theme.palette.font.sub,
  },
  context: {
    // borderRadius: '0.625rem !important',
    // transform: 'translate(0px,50px) !important',
    // '& .MuiMenu-list': {
    //   padding: '0',
    //   boxShadow: '0 0.125rem 0.625rem rgba(0, 0, 0, 0.1)',
    // },
    // '& .MuiPaper-root': {
    //   borderRadius: '0.625rem !important',
    // },
    '& .MuiPopover-paper': {
      overflow: 'visible',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.78rem',
        left: '50%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  delete: {
    width: '11.313rem',
    height: '3.81rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    padding: '1.188rem 0 1.188rem 0.938rem',
  },
  icon: {
    fontSize: '1.25rem',
    marginRight: '1.063rem',
    color: '#525e6c',
  },
  pinIcon: {
    fontSize: '1.25rem',
    color: theme.palette.font.sub,
  },
  tips: {
    display: 'flex',
    alignItems: 'center',
    height: '1.563rem',
    padding: '0 0.75rem',
    backgroundColor: theme.palette.font.sub,
    borderRadius: '5px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.75rem',
    textAlign: 'center',
    letterSpacing: '0.22px',
    fontWeight: '600',
    color: '#ffffff',
  },
  editContent: {
    height: 'fit-content',
    backgroundColor: '#7d86a9',
    borderRadius: '5px',
    padding: '0.25rem 0.625rem 0.313rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.75rem',
    color: '#fff',
  },
  delDraftPopContent: {
    fontSize: '1.142rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: 500,
  },
}));

const handleTaskID = (TASK_ID, notificationId) => {
  return TASK_ID ? Number(TASK_ID) : notificationId;
};

const initNotiPinRole = (type, roleMap) => {
  return type === 'notification' && roleMap?.[authNameE.notification_top_notificationt];
};

const initEhandoverPinRole = (roleMap) => {
  return roleMap[authNameE.eHandover_pin_note];
};

const initForwardRole = (roomType, roleMap) => {
  return roleMap[authNameE.notification_forward] && Array.isArray(roomType) && _.some(roomType, (item) => item === 2);
};

const DeleteDraftDialog = ({ showDelDraftDialog, closePop, handleDelConfirm }) => {
  const classes = useStyles();

  return (
    <DelDialog
      handleClose={closePop}
      handleCancel={closePop}
      title={i18n.t('EHANDOVER_DELETE_DRAFT')}
      cancel={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_CANCEL')}
      confirm={i18n.t('EHANDOVER_TASKITEM_CONFIRM')}
      handleConfirm={handleDelConfirm}
      dialogfootStyle={{ marginTop: '1rem' }}
      open={showDelDraftDialog}
      width="100%"
      dialogWidth="50%"
      dialogContentStyle={{ overflowY: 'auto' }}
      isCapitalize={false}
    >
      <Box className={classes.delDraftPopContent}>{i18n.t('EHANDOVER_DELETE_DRAFT_CONTENT')}</Box>
    </DelDialog>
  );
};

const Dropdown = ({
  detail,
  pin,
  deletedDate,
  deletedBy,
  deleteTaskAPI,
  pinTaskAPI,
  TASK_ID,
  roleMap,
  type,
  notificationId,
  id,
  roomType,
  handleSearch,
  setEdit,
  updater,
  isUpdate,
  showAcknowledgeBtn,
  setShowEditThisOneDialog,
  customRecurrenceConfig,
}) => {
  const classes = useStyles({ detail });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [dialog, setDialog] = React.useState(false);
  const open = Boolean(anchorEl);
  const deleteRole = roleMap[authNameE.eHandover_delete_note];
  const ehandoverPinRole = initEhandoverPinRole(roleMap);
  const notiPinRole = initNotiPinRole(type, roleMap);
  const [forwardOpen, setForwardOpen] = React.useState(false);
  const forwardRole = initForwardRole(roomType, roleMap);
  const loginInfo = useSelector((state) => state.loginInfo);
  const userRole = useSelector((state) => state.userRole);
  const editRole = useMemo(
    () =>
      userRoleList.getDetailFormat(userRole, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId)?.roleName ===
      'Ward IC'
        ? true
        : isUpdate,
    [isUpdate, loginInfo, userRole]
  );
  const [showPinNotePop, setShowPinNotePop] = useState(false);
  const [showAckDetailPop, setShowAckDetailPop] = useState(false);

  // my draft
  const [showDelDraftDialog, setShowDelDraftDialog] = useState(false);
  const [draftAnchorEl, setDraftAnchorEl] = React.useState(null);
  const draftOpen = Boolean(draftAnchorEl);
  const isMyDraftTab = type === 'myDraft';

  // schedule tab
  const [showUpdateThisOneDialog, setShowUpdateThisOneDialog] = useState(false);

  const handleClick = (event) => {
    isMyDraftTab ? setDraftAnchorEl(event.currentTarget) : setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDialogClickOpen = useCallback(() => {
    // 如果当前是schedule tab，并且该task的customRecurrence是true，就询问这次是delete这一条还是整个系列
    if (type === 'postDay' && customRecurrenceConfig?.customRecurrence) {
      setShowUpdateThisOneDialog(true);
      return;
    }
    setDialog(true);
    setAnchorEl(null);
  },[type,customRecurrenceConfig,setShowUpdateThisOneDialog,setDialog,setAnchorEl]);

  const handleDialogClose = () => {
    setDialog(false);
  };

  const handleConfirm = () => {
    deleteTaskAPI();
    setAnchorEl(null);
    setDialog(false);
  };

  const closeUpdateThisOneDialog = () => {
    setShowUpdateThisOneDialog(false);
  };

  const handleDeleteScheduleTask = ({ isJustThisOne }) => {
    deleteTaskAPI({ isJustThisOne });
    closeUpdateThisOneDialog();
  };

  const handlePinNote = ({ isManualUnpin, pinExpiryDate }) => {
    pinTaskAPI({ taskId: handleTaskID(TASK_ID, notificationId), pin: 2, isManualUnpin, pinExpiryDate });
    setAnchorEl(null);
  };

  const handleCancelPin = () => {
    pinTaskAPI({ taskId: handleTaskID(TASK_ID, notificationId), pin: 1, isManualUnpin: null, pinExpiryDate: null });
    setAnchorEl(null);
  };

  const handleForward = () => {
    setForwardOpen(true);
    setAnchorEl(null);
  };

  const handleEdit = useCallback(() => {
    // 如果当前是schedule tab，并且该task的customRecurrence是true，就询问这次edit是更新这一条还是整个系列
    if (type === 'postDay' && customRecurrenceConfig?.customRecurrence) {
      setShowEditThisOneDialog(true);
      return;
    }
    setEdit(true);
  }, [type,customRecurrenceConfig,setShowEditThisOneDialog,setEdit]);

  const pinItem = () => {
    return (
      <>
        {(ehandoverPinRole || notiPinRole) && pin ? (
          <MenuItem id={ehandoverIds.drop + id + 1} className={classes.delete} onClick={handleCancelPin}>
            <UnPinIcon className={classes.icon} />
            {i18n.t('EHANDOVER_NOTE_UNPIN')}
          </MenuItem>
        ) : (
          <MenuItem id={ehandoverIds.drop + id + 2} className={classes.delete} onClick={() => setShowPinNotePop(true)}>
            <PinBorderIcon className={classes.icon} />
            {i18n.t('EHANDOVER_NOTE_PIN')}
          </MenuItem>
        )}
        {editRole && type !== 'notification' && type !== 'deleted' && (
          <MenuItem
            id={ehandoverIds.drop + id + 3}
            className={classes.delete}
            style={{ borderTop: 'solid 1px #e4e7eb' }}
            onClick={handleEdit}
          >
            <EditIcon className={classes.icon} />
            {i18n.t('BEDSTATUS_EDIT')}
          </MenuItem>
        )}
        {Boolean(forwardRole) && (
          <MenuItem
            id={ehandoverIds.drop + id + 4}
            className={classes.delete}
            style={{ borderTop: 'solid 1px #e4e7eb' }}
            onClick={handleForward}
          >
            <ShareIcon className={classes.icon} />
            {i18n.t('EHANDOVER_NOTE_FORWARD')}
          </MenuItem>
        )}
      </>
    );
  };

  const DraftTaskPopover = () => {
    return (
      <Popover
        anchorEl={draftAnchorEl}
        open={draftOpen}
        className={classes.context}
        id="Ehandover-My-Draft-Popover"
        onClose={() => setDraftAnchorEl(null)}
        keepMounted
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        disableRestoreFocus={true}
      >
        {(
          <MenuItem id="Ehandover-My-Draft-Popover-Edit-Menu" className={classes.delete} onClick={handleEdit}>
            <EditIcon className={classes.icon} />
            {i18n.t('BEDSTATUS_EDIT')}
          </MenuItem>
        )}
        { (
          <MenuItem
            id="Ehandover-My-Draft-Popover-Del-Menu"
            className={classes.delete}
            onClick={() => {
              setDraftAnchorEl(null);
              setShowDelDraftDialog(true);
            }}
            style={{ borderTop: 'solid 1px #e4e7eb' }}
          >
            <DeleteIcon className={classes.icon} />
            {i18n.t('EHANDOVER_DELETE_DRAFT')}
          </MenuItem>
        )}
      </Popover>
    );
  };

  const loginControl = () => {
    return (
      <div className={classes.root}>
        {updater ? (
          <div className={classes.editContent}>{`Edited by ${updater.updaterCorpId} on ${moment(
            updater.updatedDate
          ).format('DD-MM-yyyy [at] HH:mm')}`}</div>
        ) : null}
        {pin && (
          <IconButton
            id={ehandoverIds.drop + id + 3}
            className={classes.btn}
            style={{ marginRight: '0.8rem', marginLeft: '1rem' }}
            onClick={ehandoverPinRole || notiPinRole ? handleCancelPin : null}
          >
            <PinIcon className={classes.pinIcon} />
          </IconButton>
        )}
        {(deleteRole || ehandoverPinRole || notiPinRole || forwardRole) && (
          <IconButton id={ehandoverIds.drop + id + 4} onClick={handleClick} className={classes.btn}>
            <MoreIcon className={classes.moreIcon} />
          </IconButton>
        )}
        {isMyDraftTab ? (
          <DraftTaskPopover />
        ) : (
          <Popover
            anchorEl={anchorEl}
            open={open}
            className={classes.context}
            id="Ehandover-Popover-666"
            onClose={handleClose}
            keepMounted
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            disableRestoreFocus={true}
          >
            {pinItem()}
            {deleteRole && type !== 'notification' && (
              <MenuItem
                id={ehandoverIds.drop + id + 5}
                className={classes.delete}
                onClick={() => {
                  handleDialogClickOpen();
                }}
                style={{ borderTop: 'solid 1px #e4e7eb' }}
              >
                <DeleteIcon className={classes.icon} />
                {i18n.t('EHANDOVER_NOTE_DELETE')}
              </MenuItem>
            )}
            {showAcknowledgeBtn && (
              <MenuItem
                id={ehandoverIds.drop + id + 7}
                className={classes.delete}
                style={{ borderTop: 'solid 1px #e4e7eb' }}
                onClick={() => {
                  setShowAckDetailPop(true);
                  setAnchorEl(null);
                }}
              >
                <AckDetailIcon className={classes.icon} />
                {i18n.t('EHANDOVER_ACK_DETAIL')}
              </MenuItem>
            )}
          </Popover>
        )}

        <DiaLog
          dialog={dialog}
          handleDialogClose={handleDialogClose}
          handleConfirm={handleConfirm}
          head={i18n.t('EHANDOVER_NOTE_DELETE_HEAD')}
          body={i18n.t('EHANDOVER_NOTE_DELETE_BODY')}
          cancel={i18n.t('EHANDOVER_NOTE_DELETE_CANCEL')}
          confirm={i18n.t('EHANDOVER_NOTE_DELETE_CONFIRM')}
        />
        <ForwardPopup
          open={forwardOpen}
          setOpen={setForwardOpen}
          notificationId={notificationId}
          handleSearch={handleSearch}
        />
        <PinNoteDialog open={showPinNotePop} closePop={() => setShowPinNotePop(false)} handlePinNote={handlePinNote} />
        {showAckDetailPop && (
          <AckDetailDialog open={showAckDetailPop} closePop={() => setShowAckDetailPop(false)} taskId={TASK_ID} />
        )}
        <DeleteDraftDialog
          showDelDraftDialog={showDelDraftDialog}
          closePop={() => setShowDelDraftDialog(false)}
          handleDelConfirm={() => {
            deleteTaskAPI();
            setShowDelDraftDialog(false);
          }}
        />

        {showUpdateThisOneDialog && (
          <UpdateThisOneDialog
            showUpdateDialog={showUpdateThisOneDialog}
            closePop={closeUpdateThisOneDialog}
            type={i18n.t('EHANDOVER_UNSENT_DELETE')}
            handleUpdate={handleDeleteScheduleTask}
          />
        )}
      </div>
    );
  };

  return deletedDate ?? false ? (
    <div className={classes.root}>
      <div className={classes.tips}>
        {i18n.t('EHANDOVER_NOTE_DELETE_TITLE', { user: deletedBy, time: deletedDate })}
      </div>
    </div>
  ) : (
    loginControl()
  );
};

const mapStateToProps = (state) => ({
  isLogin: state.loginInfo.flag,
  roleMap: state.roleMap,
});

export default connect(mapStateToProps)(Dropdown);
export { initForwardRole };
